module.exports = "/wwwroot/img/knowledge_article_page.png?ver=7dfae55d";